<template>
  <nav
    v-if="pages > 1"
    class="pager font-display text-center"
  >
    <div class="text-muted">
      Sivu {{ current }} / {{ pages }}
    </div>
    <div class="flex justify-center py-6">
      <button
        v-show="current === pages"
        aria-label="Ensimmäiselle sivulle"
        title="Ensimmäiselle sivulle"
        class="btn"
        @click="toPage(1)"
      >
        <span>
          <chevron-left-icon class="icon-mr" /> Ensimmäiselle sivulle
        </span>
      </button>
      <button
        v-show="current !== pages"
        aria-label="Seuraavalle sivulle"
        title="Seuraalle sivulle"
        class="btn"
        @click="nextPage"
      >
        <span>
          Seuraavalle sivulle <chevron-right-icon class="icon-ml" />
        </span>
      </button>
    </div>
    <ul class="list-reset grid grid-flow-col gap-2 lg:gap-3 py-4 justify-center">
      <li class="whitespace-nowrap items-center hidden sm:flex">
        <button
          aria-label="Edellinen sivu"
          title="Edellinen sivu"
          class="btn btn-tertiary w-8 h-8 p-0"
          :class="{'opacity-0': current === 1}"
          :disabled="current === 1"
          @click="prevPage"
        >
          <span>
            <chevron-left-icon />
          </span>
        </button>
      </li>
      <li
        v-for="(page, i) in items"
        :key="i+'_'+page"
        class="whitespace-nowrap items-center md:flex"
        :class="{ 'flex': current === page, 'hidden': current !== page }"
        :data-current="current === page"
      >
        <span v-if="isEllipsis(page)" class="text-12 sm:text-18 block w-8 h-8 flex items-center justify-center bg-transparent">
          {{ page }}
        </span>
        <button
          v-else
          :class="{ 'btn-tertiary': current !== page }"
          class="btn w-8 h-8 text-12 p-0"
          @click="toPage(page)"
        >
          {{ page }}
        </button>
      </li>
      <li class="whitespace-nowrap items-center hidden sm:flex">
        <button
          aria-label="Seuraava sivu"
          title="Seuraava sivu"
          class="btn btn-tertiary w-8 h-8 p-0"
          :class="{'opacity-0': current === pages}"
          :disabled="current === pages"
          @click="nextPage"
        >
          <span>
            <chevron-right-icon />
          </span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@bit/vekenkaluste.veke-ui.icons'

export default {
  name: 'Pager',
  components: { ChevronLeftIcon, ChevronRightIcon },
  props: {
    perPage: {
      type: Number,
      required: false,
      default: 9
    },
    itemAmount: {
      type: Number,
      required: false,
      default: 9
    },
    current: {
      type: Number,
      required: false,
      default: 1
    }
  },
  emits: ['page-change'],
  data () {
    return {
      ellipsis: '...',
      maxTiles: 7
    }
  },
  computed: {
    pages () {
      return Math.ceil(this.itemAmount / this.perPage)
    },
    tiles () {
      return this.pages < this.maxTiles ? this.pages : this.maxTiles
    },
    isFullSize () {
      return this.pages > this.maxTiles
    },
    items () {
      const tilesOnOneSize = Math.floor((this.tiles - 1) / 2)
      const diff = (this.current - tilesOnOneSize <= 0) ? this.current - 1 : (this.current + tilesOnOneSize >= this.pages) ? this.tiles - 1 - (this.pages - this.current) : tilesOnOneSize
      const arr = Array.from({ length: this.pages }, (_, i) => this.current - diff + i)
      if (this.isFullSize) {
        arr[0] = 1
        arr[1] = (this.current > this.tiles - tilesOnOneSize) ? this.ellipsis : arr[1]
        arr[this.tiles - 2] = (this.current + tilesOnOneSize < this.pages) ? this.ellipsis : arr[this.tiles - 2]
        arr[this.tiles - 1] = this.pages
      }
      return arr.slice(0, this.tiles)
    }
  },
  methods: {
    isEllipsis (page) {
      return page === this.ellipsis
    },
    toPage (page) {
      this.$emit('page-change', page)
    },
    prevPage () {
      if (this.current > 1) {
        this.toPage(this.current - 1)
      }
    },
    nextPage () {
      if (this.current < this.pages) {
        this.toPage(this.current + 1)
      }
    }
  }
}
</script>
